module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/library/modules/_redefine.js
// module id = ../../../../core-js/library/modules/_redefine.js
// module chunks = 3